<template>
	<div class="horizontal-divider">
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1020 25.6">
			<g id="divider-end-left">
				<polygon class="cls-1" points="40 2 40 0 0 0 2 2 40 2" />
				<polygon class="cls-1" points="40 8 40 6 20 6 22 8 40 8" />
				<polygon class="cls-3" points="2 2 0 4 40 4 40 2 2 2" />
				<polygon class="cls-3" points="22 8 20 10 40 10 40 8 22 8" />
				<polygon class="cls-2" points="0 0 0 4 2 2 0 0" />
				<polygon class="cls-2" points="20 6 20 10 22 8 20 6" />
			</g>
			<g id="divider-scale-left">
				<rect class="cls-1" x="40" y="6" width="420" height="2" />
				<rect class="cls-1" x="40" width="420" height="2" />
				<rect class="cls-3" x="40" y="2" width="420" height="2" />
				<rect class="cls-3" x="40" y="8" width="420" height="2" />
			</g>
			<g id="divider-middle">
				<path
					class="cls-1"
					d="M519.94,0l-9.94,9.94-9.94-9.94h-40.06v2h29.23l14.36,14.35-1.42,1.42-2.17,2.17-13.94-13.94h-26.06v2h25.24l14.76,14.76,20.77-20.76h7.17l-12.94,12.94-2.17-2.17-1.41,1.41,2.17,2.17-1.42,1.42-2.17,2.17-2.17-2.17-1.41,1.41,2.17,2.17,1.41,1.41,1.41-1.41,2.17-2.17,1.42-1.42,1.41-1.41,6.35-6.35,2-2,1.58-1.57,4.43-4.43h29.23V0h-40.06ZM507.17,12.77l-2.17,2.17-12.94-12.94h7.17l9.36,9.35-1.42,1.42Z"
				/>
				<polygon
					class="cls-1"
					points="560 6 560 8 534.76 8 532.76 10 521.41 21.35 520 22.76 518.59 21.35 516.42 19.18 517.83 17.77 520 19.94 533.94 6 560 6"
				/>
				<polygon
					class="cls-3"
					points="516.42 19.18 518.59 21.35 520 22.76 521.41 21.35 532.76 10 534.76 8 560 8 560 10 535.6 10 520 25.6 515 20.6 510 25.6 505 20.6 500 25.6 484.4 10 460 10 460 8 485.24 8 500 22.76 520.77 2 527.94 2 525.94 4 521.6 4 511.42 14.18 513.59 16.35 512.17 17.77 510 15.6 506.42 19.18 508.59 21.35 510 22.76 511.41 21.35 513.58 19.18 515 17.76 516.41 16.35 522.76 10 524.76 8 526.34 6.43 530.77 2 560 2 560 4 531.6 4 516.42 19.18"
				/>
				<polygon
					class="cls-3"
					points="503.59 16.35 502.17 17.77 488.4 4 460 4 460 2 489.23 2 503.59 16.35"
				/>
				<polygon
					class="cls-3"
					points="508.59 11.35 507.17 12.77 498.4 4 494.06 4 492.06 2 499.23 2 508.59 11.35"
				/>
			</g>
			<g id="divider-scale-right">
				<rect class="cls-3" x="560" y="2" width="420" height="2" />
				<rect class="cls-1" x="560" y="6" width="420" height="2" />
				<rect class="cls-3" x="560" y="8" width="420" height="2" />
				<rect class="cls-1" x="560" width="420" height="2" />
			</g>
			<g id="divider-end-right">
				<polygon class="cls-2" points="1020 0 1020 4 1018 2 1020 0" />
				<polygon
					class="cls-3"
					points="980 4 1020 4 1018 2 980 2 980 4"
				/>
				<polygon
					class="cls-1"
					points="998 8 1000 6 980 6 980 8 998 8"
				/>
				<polygon
					class="cls-3"
					points="980 8 980 10 1000 10 998 8 980 8"
				/>
				<polygon
					class="cls-1"
					points="1018 2 1020 0 980 0 980 2 1018 2"
				/>
				<polygon class="cls-2" points="1000 10 1000 6 998 8 1000 10" />
			</g>
		</svg>
	</div>
</template>

<script lang="ts" setup></script>

<style lang="scss" scoped>
.cls-1 {
	fill: #edd091;
}

.cls-2 {
	fill: #c4951e;
}

.cls-3 {
	fill: #63451a;
}
</style>
